<template>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a
        class="nav-link"
        :class="[selectedView == 'object' ? 'active' : 'inactive-tab']"
        @click="select('object')"
        aria-current="page"
        href="#"
      >Object</a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        :class="[selectedView == 'xml' ? 'active' : 'inactive-tab']"
        @click="select('xml')"
        href="#"
      >XML</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'InvoiceDetailTab',
  emits: ['click'],
  data() {
    return {
      selectedView: 'object'
    };
  },
  methods: {
    select(view) {
      this.selectedView = view;
      this.$emit('click', view);
    }
  }
};
</script>

<style scoped>
.inactive-tab {
  color: darkblue;
}

.inactive-tab:hover {
  color: #06C; /* Een donkerdere tint blauw voor hover effect */
}
</style>
